'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _groupBy = require('lodash/groupBy');var _groupBy2 = _interopRequireDefault(_groupBy);


var _StaticCompanyMap = require('./StaticCompanyMap');var _StaticCompanyMap2 = _interopRequireDefault(_StaticCompanyMap);
var _DynamicCompanyMap = require('./DynamicCompanyMap');var _DynamicCompanyMap2 = _interopRequireDefault(_DynamicCompanyMap);


var _Company = require('../Company');


var _CompanyMap = require('./CompanyMap.scss');var styles = _interopRequireWildcard(_CompanyMap);
var _OptionTypeSwitcher = require('../OptionTypeSwitcher/OptionTypeSwitcher');var _OptionTypeSwitcher2 = _interopRequireDefault(_OptionTypeSwitcher);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// styles
var CompanyMap = function (_Component) {_inherits(CompanyMap, _Component);function CompanyMap(props) {_classCallCheck(this, CompanyMap);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.












    getPropertiesIdsMap = function () {
      var properties = _this.props[_this.state.displayPinsFor];
      return properties.reduce(function (acc, property) {
        acc[property.id] = Object.assign({}, property);
        return acc;
      }, {});
    };_this.

    groupPins = function () {
      var properties = _this.props[_this.state.displayPinsFor];

      if (!properties || !properties.length) return {};

      return (0, _groupBy2.default)(properties, function (_ref) {var _ref$address$location = _ref.address.location,lat = _ref$address$location.lat,lon = _ref$address$location.lon;return lat + '|' + lon;});
    };_this.

    switchToDynamicMap = function () {
      _this.setState({ isDynamicMap: true });
    };_this.

    handleSelectOption = function (evt) {
      evt.preventDefault();var
      value = evt.target.value;

      if (value !== _this.state.displayPinsFor) {
        _this.setState({ displayPinsFor: value });
      }
    };_this.

    renderSwitchTitle = function () {return (
        _react2.default.createElement(_OptionTypeSwitcher2.default, {
          translate: _this.props.translate('companyPage'),
          title: _this.props.translate('companyPage', 'propertiesMap').toString(),
          activeOption: _this.state.displayPinsFor,
          hasPropertiesForSale: _this.state.hasPropertiesForSale,
          hasPropertiesForRent: _this.state.hasPropertiesForRent,
          handleSelectOption: _this.handleSelectOption }));};_this.



    renderStaticMap = function () {return (
        _react2.default.createElement(_StaticCompanyMap2.default, {
          translate: _this.props.translate,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          pinsType: _this.state.displayPinsFor,
          groupedProperties: _this.groupPins(),
          switchToDynamicMap: _this.switchToDynamicMap }));};_this.



    renderDynamicMap = function () {return (
        _react2.default.createElement(_DynamicCompanyMap2.default, {
          translate: _this.props.translate,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          pinsType: _this.state.displayPinsFor,
          groupedProperties: _this.groupPins(),
          propertiesIdsMap: _this.getPropertiesIdsMap(),
          reviewedPins: _this.props.reviewedPins,
          setPinAsReviewed: _this.props.setPinAsReviewed,
          openDetails: _this.props.openDetails,
          isRtl: _this.props.isRtl }));};var hasPropertiesForSale = !!(0, _get2.default)(_this.props, [_Company.OPTION_TYPES_COMPANY.SALE, 'length']);var hasPropertiesForRent = !!(0, _get2.default)(_this.props, [_Company.OPTION_TYPES_COMPANY.RENT, 'length']);var propertiesOnlyForRent = !hasPropertiesForSale && hasPropertiesForRent;_this.state = { hasPropertiesForSale: hasPropertiesForSale, hasPropertiesForRent: hasPropertiesForRent, isDynamicMap: true, displayPinsFor: propertiesOnlyForRent ? _Company.OPTION_TYPES_COMPANY.RENT : _Company.DEFAULT_DISPLAYED_PINS };return _this;}CompanyMap.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.companyMap },
        this.renderSwitchTitle(),
        this.state.isDynamicMap ? this.renderDynamicMap() : this.renderStaticMap()));


  };return CompanyMap;}(_react.Component);


CompanyMap.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  forSale: _propTypes2.default.array,
  forRent: _propTypes2.default.array,
  reviewedPins: _propTypes2.default.array,
  setPinAsReviewed: _propTypes2.default.func,
  openDetails: _propTypes2.default.func };exports.default =


CompanyMap;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyMap/CompanyMap.js
// module id = 2628
// module chunks = 0